<template>
  <div class="fpx">
    <div class="items">
      <el-form :model="billplzForm" :rules="rulesForm" ref="billplzForm" label-width="0" class="billplzForm">
        <el-form-item prop="amount" v-if="!!!$route.query.tradeSerialNo">
          <p>{{pc_lang.Amount}}</p>
          <el-input v-model="billplzForm.amount" prefix-icon="el-icon-money" autocomplete="off" :placeholder="pc_lang.Please_enter_the_amount" size="medium"></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <p>{{pc_lang.Cardholders_Name}}</p>
          <el-input v-model="billplzForm.name" prefix-icon="el-icon-user" autocomplete="off" :placeholder="pc_lang.Fill_in_cardholder_name" size="medium"></el-input>
        </el-form-item>
        <el-form-item prop="email">
          <p>{{pc_lang.Email_address}}</p>
          <el-input v-model="billplzForm.email" prefix-icon="el-icon-message" autocomplete="off" :placeholder="pc_lang.Enter_your_email_address" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <div v-show="0" class="callbackForm" v-html="callbackForm"></div>
      <div class="submit">
        <p>我已阅读并同意 <span><a href="https://www.billplz.com/agreement.pdf" target="blank">《BILLPLZ条款》</a></span></p>
        <el-button type="primary" size="medium" class="nextStep" @click="regForm('billplzForm')">{{pc_lang.Next_step}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as RegExp from '@/utils/RegExp'
import * as API_PAY from '@/api/pay'

export default {
  name: 'BILLPLZ',
  props: ['currencyShort'],
  components: {

  },
  data(){

    return {
      // 提交完成
      finish: 0,
      billplzForm: {
        amount: '',
        name: '',
        email: '',
      },
      bankList: [],
      callbackForm: ''
    }
  },
  computed: {
    rulesForm() {
      // email验证
      var validateEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Enter_your_email_address));
        } else if (!RegExp.email.test(value)) {
          callback(new Error(this.pc_lang.Enter_your_correct_email_address));
        } else {
          callback();
        }
      };
      // 金额验证
      var validateMoney = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Please_enter_the_amount));
        } else if (!RegExp.money.test(value)) {
          callback(new Error(this.pc_lang.Please_enter_the_correct_amount));
        } else {
          callback();
        }
      };
      return {
        amount: [
          { validator: validateMoney, trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.pc_lang.Fill_in_cardholder_name, trigger: 'blur' }
        ],
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ]
      }
    }
  },
  async mounted() {

  },
  created() {

  },
  methods: {
    /* 表单验证 */
    regForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getPayItem().then(()=>{
            document.querySelector('.callbackForm form').submit()
          })
        }else{
          return false
        }
      })
    },
    /* 获取支付表单 */
    getPayItem() {
      return new Promise((resolve, reject)=> {
        let params = {
          paymentPluginId: 'billplzPayPlugin',
          payMode: 'normal',
          clientType: 'PC',
          sn: this.$route.query.tradeSerialNo || new Date().getTime(),
          tradeType: this.$route.query.tradeSerialNo == undefined ? 'recharge' : 'order',
          amount: this.$route.query.tradeSerialNo == undefined ? this.billplzForm.amount : '',
          name: this.billplzForm.name,
          email: this.billplzForm.email,
          bankId: this.billplzForm.bank
        }
        API_PAY.getPayQrCode(params.tradeType, params.sn, params).then(res=> {
          this.callbackForm = res.data.gateway_url
          resolve(res)
        },rej=> {
          reject(rej)
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.fpx{

  .el-input,.el-select{
    width: 450px;
  }
  .el-form-item{
    margin-bottom: 14px;
  }
  .submit{
    p{
      padding: 10px 0;
      font-size: 12px;
      span{
        color: #007DD1;
        cursor: pointer;
      }
    }
  }
}
</style>